module.exports = __webpack_public_path__ + "img/login-left.bcc5e579.png";